import React, { useState, useEffect } from 'react';
import {
  Container, TextField, Button, MenuItem, Typography, Alert
} from '@mui/material';
import contribuenteApi from '../../api/contribuenteApi';
import studioApi from '../../api/studioApi';
import { useContext } from 'react';
import { AuthContext } from '../../auth/AuthContext';
import {  useParams, useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import BackButtonDesktop from '../../components/BackButtonDesktop';

const extractErrorMessage = (error) => {
  if (!error) return 'Errore sconosciuto';
  if (error.response?.data) return String(error.response.data);
  if (error.message) return error.message;
  return JSON.stringify(error);
};

export default function ContribuenteCreatePage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const userId = params.get('userId');
  console.log("userIdFromUrl",userId);
  const { user } = useContext(AuthContext);
  const isAdmin = user?.role === 'ADMIN';
  const isStudio = user?.role === 'STUDIO';
  console.log("userId",userId);

  const [users, setUsers] = useState([]);
  const [err, setErr] = useState(null);

  const [form, setForm] = useState({
    nome: '',
    cognome: '',
    codiceFiscale: '',
    partitaIVA: '',
    email: '',
    regimeFiscale: 'ORDINARIO',
    studioId:
      userId ??
      (isStudio ? user.userId : userId
      )
  });
  console.log("form iniziale",form);
  /**
   * Carico lista utenti SOLO se:
   * - ADMIN
   * - non ho userId in query string
   */
  useEffect(() => {
    if (isAdmin && !userId) {
      studioApi.list()
        .then(r => setUsers(r.data.content || []))
        .catch(e => setErr(extractErrorMessage(e)));
    }
  }, [isAdmin, userId]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    console.log("sto salvando",form);
    try {
      await contribuenteApi.create(form);
    if (isAdmin) {
      navigate('/contribuenti');
    } else if (isStudio) {
      navigate(`/contribuenti/bystudio/${user.userId}`);
      // user.id è l'utente dello studio loggato
    }
    } catch (e) {
      setErr(extractErrorMessage(e));
    }
  };
  return (
    <Container>
    <BackButtonDesktop />
      <Typography variant="h5" sx={{ mb: 2 }}>
        Crea Contribuente
      </Typography>

      {err && <Alert severity="error" sx={{ mb: 2 }}>{String(err)}</Alert>}

      <form onSubmit={submit}>
        <TextField fullWidth sx={{ my: 1 }} label="Nome"
          value={form.nome}
          onChange={e => setForm({ ...form, nome: e.target.value })}
          required
        />

        <TextField fullWidth sx={{ my: 1 }} label="Cognome"
          value={form.cognome}
          onChange={e => setForm({ ...form, cognome: e.target.value })}
          required
        />

        <TextField fullWidth sx={{ my: 1 }} label="Codice Fiscale"
          value={form.codiceFiscale}
          onChange={e => setForm({ ...form, codiceFiscale: e.target.value })}
        />

        <TextField fullWidth sx={{ my: 1 }} label="Partita IVA"
          value={form.partitaIVA}
          onChange={e => setForm({ ...form, partitaIVA: e.target.value })}
        />

        <TextField fullWidth sx={{ my: 1 }} label="Email"
          type="email"
          value={form.email}
          onChange={e => setForm({ ...form, email: e.target.value })}
        />

        <TextField select fullWidth sx={{ my: 1 }} label="Regime Fiscale"
          value={form.regimeFiscale}
          onChange={e => setForm({ ...form, regimeFiscale: e.target.value })}
        >
          {['ORDINARIO', 'FORFETTARIO', 'MINIMI', 'ALTRO']
            .map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
        </TextField>

        {/* ADMIN senza userId → scelta utente */}
        {isAdmin && !userId && (
          <TextField select fullWidth sx={{ my: 1 }}
            label="Studio"
            value={form.studioId}
            disabled={!!userId}
            onChange={e => setForm({ ...form, studioId: e.target.value })}
            required
          >
            {users.map(u =>
              <MenuItem key={u.utenteId} value={u.utenteId}>{u.ragionesociale}</MenuItem>
            )}
          </TextField>
        )}

        <Button variant="contained" type="submit" sx={{ mt: 2 }}>
          Crea
        </Button>
      </form>
    </Container>
  );
}